module.exports = __webpack_public_path__ + "media/images/advance-98b775621520b812fca8cd39d570343b.png";